
import { Component, Vue } from 'vue-property-decorator'

    @Component({
      name: 'TrustPilot'
    })
export default class TrustPilot extends Vue {
}
